module.exports = __webpack_public_path__ + "static/media/park3.ae1258bd.png";